import { z } from "zod";
import { MatchMode, OrchestrationCriteriaSchema } from "./orchestrationCriteria.entity";

export const orchestratedEntityBaseSchema = {
  id: z.string(),
  active: z.boolean().default(true),
  ticker: z.string().min(1, "Ticker is required"),
  criteria: OrchestrationCriteriaSchema.optional(),
};

export const actionsMapSchema = z.record(z.string(), z.string()).default({});

export function createEmptyCriteria() {
  return {
    matchMode: MatchMode.ALL,
    conditions: [],
  };
}
